module.exports = __webpack_public_path__ + "static/media/nextArrow.24c7abfb.webp";